var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"footerB"},[_c('ul',_vm._l((_vm.box),function(site){return _c('li',{class:{hover:site.hover},on:{"click":function($event){_vm.selectP(site)}}},[_c('router-link',{attrs:{"to":site.url}})],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34ba7d20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/footerMenu.vue
// module id = null
// module chunks = 